import React from "react";
import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";
import {withAuth} from "../../withAuth";
import {withRouter} from "react-router-dom";
import ButtonStandart from "../../Elements/Buttons/ButtonStandart/ButtonStandart";
import {Mutation} from "react-apollo";
import axios from "axios";
import { KYCLang } from "./KYC_lang";
import './KYC_style.css';

import {KYC_USER, ADD_KYC_DOC1, ADD_KYC_DOC2, ADD_KYC_DOC3, SAVE_KYC} from "../../../queries";

import kyc_start from "../../../img/KYC/kyc_start.svg";
import info from "../../../img/KYC/info.svg";
import back from "../../../img/KYC/back.png";
import protect from "../../../img/KYC/protect.svg";
import idcard from "../../../img/KYC/id_card.svg";
import driver from "../../../img/KYC/driver_license.svg";
import passport from "../../../img/KYC/passport.svg";
import id_good from "../../../img/KYC/fsize.svg";
import id_cut from "../../../img/KYC/goverment.svg";
import id_blur from "../../../img/KYC/expiried.svg";
import id_reflect from "../../../img/KYC/edit.svg";
import check from "../../../img/KYC/check.png";
import close from "../../../img/KYC/close-red.png";
import photoimg from "../../../img/KYC/camera.svg";
import complaint from "../../../img/KYC/complaint.png";
import ligth from "../../../img/KYC/light.svg";
import filter from "../../../img/KYC/filter.svg";
import fsize from "../../../img/KYC/full_face.svg";
import glasses from "../../../img/KYC/glasses.svg";

import goverment2 from "../../../img/KYC/goverment2.svg";
import history from "../../../img/KYC/history.svg";
import note from "../../../img/KYC/note.svg";
import profile from "../../../img/KYC/profile.svg";

class KYC_inner extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            SITE_ADDRESS: "https://launch.artyfact.game",
            email: this.props.session.email,
            step1: true,
            step2: false,
            step3: false,
            step4: false,
            step5: false,
            step6: false,
            check: false,
            doc_type: 1,
            name: this.props.session.Name,
            surname: this.props.session.Surname,
            birthday: this.props.session.Birthday,
            postalcode: this.props.session.PostalCode,
            city: this.props.session.City,
            address: this.props.session.Address,
            country: this.props.session.Country,
            nationality: this.props.session.Nationality,
            FileImageToBig: false,
            fileImage1: '',
            FileImageToBig1: false,
            fileImage2: '',
            FileImageToBig2: false,
            fileImage3: '',
            FileImageToBig3: false,
            doc1: '',
            doc2: '',
            selfie: '',
            uploadDoc1: false,
            uploadDoc2: false,
            uploadDoc3: false,
            start: this.props.userKYC ? this.props.userKYC.start : false,
            status: this.props.userKYC ? this.props.userKYC.status : false,
            status_check: this.props.userKYC ? this.props.userKYC.status_check : false,
            status_doc1: this.props.userKYC ? this.props.userKYC.status_doc1 : false,
            status_doc2: this.props.userKYC ? this.props.userKYC.status_doc2 : false,
            status_selfie: this.props.userKYC ? this.props.userKYC.selfie : false,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en'
        };
    }

    componentDidMount() {
        if (this.state.start && !this.state.status_check) {
            this.setState({step1: false, step6: true});
        }
        if (this.state.status_check) {
            this.setState({step1: false, step6: false, check: true});
        }        
    }

    ChangeStep = (event, step) => {
        event.preventDefault();
        this.setState({
            step1 : step == 'step1' ? true : false,
            step2 : step == 'step2' ? true : false,
            step3 : step == 'step3' ? true : false,
            step4 : step == 'step4' ? true : false,
            step5 : step == 'step5' ? true : false,
            step6 : step == 'step6' ? true : false
        });
    }

    SelectDoc = (event, dtype) => {
        event.preventDefault();
        this.setState({ doc_type : dtype });
    }

    ChangeElement = event => {
        const {name, value} = event.target;
        this.setState({[name] : value});
    };

    CheckUserInformation = () => {
        if (this.state.name && this.state.surname && this.state.birthday && this.state.nationality && this.state.country && this.state.city && this.state.address && this.state.city && this.state.postalcode) {
            return true;
        }
        return false;
    }

    UserUpdate = (event, KYCUser) => {
        event.preventDefault();
        KYCUser().then(({data}) => {
            this.ChangeStep(event, 'step3');
        })
    };

    CheckDocuments = () => {
        if (this.state.doc_type == 1) {
            if (this.state.uploadDoc1 && this.state.uploadDoc2) { return true; }
            return false;
        } else {
            if (this.state.uploadDoc1) { return true; }
            return false;            
        }
    }

    CheckSelfie = () => {
        if (this.state.uploadDoc3) { return true; }
        return false;
    }

    UploadImage(e, doc_type) {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        if (file.size > 10240000) {
            alert('File more than 10MB');
            this.setState({
                FileImageToBig : true,
            });
            if (doc_type == 'doc1') {
                this.setState({ FileImageToBig1: true });
            }
            if (doc_type == 'doc2') {
                this.setState({ FileImageToBig2: true });
            }
            if (doc_type == 'selfie') {
                this.setState({ FileImageToBig3: true });
            }
        } else
        {
            let fileName = file.name;

            reader.onloadend = () => {
                this.setState({
                    FileImageToBig : false, ImagePreviewUrl: reader.result
                });

                if (doc_type == 'doc1') {
                    this.setState({ fileImage1: file });
                }
                if (doc_type == 'doc2') {
                    this.setState({ fileImage2: file });
                }
                if (doc_type == 'selfie') {
                    this.setState({ fileImage3: file });
                }
            };            

            reader.readAsDataURL(file);
            // console.log('handle uploading-file', file.name);
            // console.log('size', file.size);
            // console.log('reader.result-', this.state.ImagePreviewUrl);

            let data2 = new FormData();
            let NewFileNameArr = fileName.split('.');
            let NewFileName = fileName.split('.')[NewFileNameArr.length-1];
            let newFile;

            if (doc_type == 'doc1') {
                newFile = new File([file], this.state.email + '_doc1.' + NewFileName, {
                    type: file.type,
                });
                this.setState({
                    doc1: this.state.email + '_doc1.' + NewFileName
                });
            }
            if (doc_type == 'doc2') {
                newFile = new File([file], this.state.email + '_doc2.' + NewFileName, {
                    type: file.type,
                });
                this.setState({
                    doc2: this.state.email + '_doc2.' + NewFileName
                });
            }
            if (doc_type == 'selfie') {
                newFile = new File([file], this.state.email + '_selfie.' + NewFileName, {
                    type: file.type,
                });
                this.setState({
                    selfie: this.state.email + '_selfie.' + NewFileName
                });
            }

            data2.append('file', newFile);

            for (var key of data2.entries()) {
                console.log(key[0] + ', ' + key[1]);
            }
            console.log("data2", data2);

            // axios.post("https://launch.artyfact.game/upload", data2, {
            //     headers: {"Access-Control-Allow-Origin": "*"}
            // })

            fetch(`${this.state.SITE_ADDRESS}/upload`, {
                method: 'POST',
    
                body: data2,
                dataType: "jsonp"
            }).then(res => { 
                if (doc_type == 'doc1') {
                    document.getElementById('KYCdoc1').click();
                }
                if (doc_type == 'doc2') {
                    document.getElementById('KYCdoc2').click();
                }
                if (doc_type == 'selfie') {
                    document.getElementById('KYCselfie').click();
                }
            })
            .catch(error => { 
                console.error(error.response)
            });
        }
    }

    KYCdoc1 = (event, addKYCdoc1) => {
        event.preventDefault();
        addKYCdoc1().then(({data}) => {
            this.setState({uploadDoc1: true});
        })
    };

    KYCdoc2 = (event, addKYCdoc2) => {
        event.preventDefault();
        addKYCdoc2().then(({data}) => {
            this.setState({uploadDoc2: true});
        })
    };

    KYCdoc3 = (event, addKYCdoc3) => {
        event.preventDefault();
        addKYCdoc3().then(({data}) => {
            this.setState({uploadDoc3: true});
        })
    };

    KYCsave = (event, saveKYC) => {
        event.preventDefault();
        saveKYC().then(({data}) => {
            this.ChangeStep(event, 'step6');
        });        
    }    
    
    render(){
        let date = new Date();
        let dateCompile = new Date( date.getTime() + 86400000 );
        let dateReview = `${dateCompile.getFullYear()}-${dateCompile.getMonth()}-${dateCompile.getDate()}`;
        return (
            <div className="PersonalPage">               

                <TopPafeInfo session={this.props.session} />
                <div className="PersonalPageMain StandartPartMain">
                    <div className="PersonalPageMainPersonalInformation StandartBigElement">
                        <div className="IndexMainElementIn">
                            <div className="StandartElementTitle">KYC</div>
                            <div className="StandartElementTopBorder"/>
                        </div>

                        <div className="kyc-block">
                            { this.state.check && 
                                <ul className="kyc-ul2 mt25px">
                                    <li>Type of document: 
                                        { this.state.doc_type == 1 && ' ID Card' }
                                        { this.state.doc_type == 2 && ' Passport' }
                                        { this.state.doc_type == 3 && ' Driver’s License' }
                                    </li>
                                    <li>
                                        { this.state.doc_type == 1 && 'ID Card front: ' }
                                        { this.state.doc_type == 2 && 'Passport: ' }
                                        { this.state.doc_type == 3 && 'Driver’s License: ' }
                                        { this.state.status_doc1 ? (
                                            <img width="16px" style={{marginLeft: '5px'}} src={check} /> 
                                        ) : (
                                            <img width="14px" style={{marginLeft: '5px'}} src={close} />
                                        )}
                                    </li>
                                    { this.state.status_doc1 && 
                                        <li>
                                            { this.state.doc_type == 1 && 'ID Card back: ' }
                                            { this.state.status_doc2 ? (
                                                <img width="16px" style={{marginLeft: '5px'}} src={check} /> 
                                            ) : (
                                                <img width="14px" style={{marginLeft: '5px'}} src={close} />
                                            )}
                                        </li>
                                    }
                                    <li>Selfie: 
                                        { this.state.status_selfie ? (
                                            <img width="16px" style={{marginLeft: '5px'}} src={check} /> 
                                        ) : (
                                            <img width="14px" style={{marginLeft: '5px'}} src={close} />
                                        )}
                                    </li>
                                    <li>KYC status: 
                                        { this.state.status ? (
                                            <img width="16px" style={{marginLeft: '5px'}} src={check} /> 
                                        ) : (
                                            <img width="14px" style={{marginLeft: '5px'}} src={close} />
                                        )}
                                    </li>
                                </ul>
                            }

                            { this.state.step1 && 
                            <>
                            <img className="kyc-start-img" src={kyc_start} />
                            <div className="row">
                                <div className="col-md-12" style={{textAlign: "center"}}>
                                    <div className="kyc-info">
                                        {KYCLang.step1_1[this.state.Language]}<br/>
                                        {KYCLang.step1_2[this.state.Language]}
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="kyc-ttl" style={{textAlign: "center", marginBottom: '20px'}}>
                                        {KYCLang.step1_3[this.state.Language]}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-3 mob-50w">
                                            <div className="identity-img-area-grid">
                                                <img className="identity-img-example" style={{width: '35px', height: '35px'}} src={note} />
                                                <div className="kyc-area-ttl2" style={{marginTop: '8px'}}>
                                                    {KYCLang.step1_4[this.state.Language]}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 mob-50w">
                                            <div className="identity-img-area-grid">
                                                <img className="identity-img-example" style={{width: '30px', height: '35px'}} src={goverment2} />
                                                <div className="kyc-area-ttl2" style={{marginTop: '8px'}}>
                                                    {KYCLang.step1_5[this.state.Language]}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pb40">
                                        <div className="col-md-3"></div>
                                        <div className="col-md-3 mob-50w">
                                            <div className="identity-img-area-grid">
                                                <img className="identity-img-example" style={{width: '35px', height: '35px'}} src={profile} />
                                                <div className="kyc-area-ttl2" style={{marginTop: '8px'}}>
                                                    {KYCLang.step1_6[this.state.Language]}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 mob-50w">
                                            <div className="identity-img-area-grid">
                                                <img className="identity-img-example" style={{width: '40px', height: '40px'}} src={history} />
                                                <div className="kyc-area-ttl2" style={{marginTop: '8px'}}>
                                                    {KYCLang.step1_7[this.state.Language]}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div onClick={event => this.ChangeStep(event, 'step2')}>
                                        <ButtonStandart ssilka='#' classname='ButtonStandart mt25px kyc-big-button' label={KYCLang.step1_8[this.state.Language]}/>
                                    </div>
                                </div>
                            </div>
                            </>
                            }

                            { this.state.step2 && 
                            <>  
                                <img className="kyc-back" onClick={event => this.ChangeStep(event, 'step1')} src={back} />
                                <div className="kyc-ttl">
                                    {KYCLang.step1_4[this.state.Language]}
                                </div>
                                <div className="row mt25px">
                                    <div className="col-md-6 mob-50w">
                                        <div class="mb-3 form-area1">
                                            <label class="form-label">{KYCLang.step2_1[this.state.Language]}*</label>
                                            <select name="nationality" class={this.state.nationality ? "form-select" : "form-select error-border"} value={this.state.nationality ? this.state.nationality : ''} onChange={this.ChangeElement} >
                                                <option>{KYCLang.step2_1[this.state.Language]}</option>
                                                <option value="Afghanistan">Afghanistan</option>
                                                <option value="Åland Islands">Åland Islands</option>
                                                <option value="Albania">Albania</option>
                                                <option value="Algeria">Algeria</option>
                                                <option value="American Samoa">American Samoa</option>
                                                <option value="Andorra">Andorra</option>
                                                <option value="Angola">Angola</option>
                                                <option value="Anguilla">Anguilla</option>
                                                <option value="Antarctica">Antarctica</option>
                                                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                                <option value="Argentina">Argentina</option>
                                                <option value="Armenia">Armenia</option>
                                                <option value="Aruba">Aruba</option>
                                                <option value="Australia">Australia</option>
                                                <option value="Austria">Austria</option>
                                                <option value="Azerbaijan">Azerbaijan</option>
                                                <option value="Bahamas">Bahamas</option>
                                                <option value="Bahrain">Bahrain</option>
                                                <option value="Bangladesh">Bangladesh</option>
                                                <option value="Barbados">Barbados</option>
                                                <option value="Belarus">Belarus</option>
                                                <option value="Belgium">Belgium</option>
                                                <option value="Belize">Belize</option>
                                                <option value="Benin">Benin</option>
                                                <option value="Bermuda">Bermuda</option>
                                                <option value="Bhutan">Bhutan</option>
                                                <option value="Bolivia">Bolivia</option>
                                                <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                                <option value="Botswana">Botswana</option>
                                                <option value="Bouvet Island">Bouvet Island</option>
                                                <option value="Brazil">Brazil</option>
                                                <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                                <option value="Brunei Darussalam">Brunei Darussalam</option>
                                                <option value="Bulgaria">Bulgaria</option>
                                                <option value="Burkina Faso">Burkina Faso</option>
                                                <option value="Burundi">Burundi</option>
                                                <option value="Cambodia">Cambodia</option>
                                                <option value="Cameroon">Cameroon</option>
                                                <option value="Canada">Canada</option>
                                                <option value="Cape Verde">Cape Verde</option>
                                                <option value="Cayman Islands">Cayman Islands</option>
                                                <option value="Central African Republic">Central African Republic</option>
                                                <option value="Chad">Chad</option>
                                                <option value="Chile">Chile</option>
                                                <option value="China">China</option>
                                                <option value="Christmas Island">Christmas Island</option>
                                                <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                                <option value="Colombia">Colombia</option>
                                                <option value="Comoros">Comoros</option>
                                                <option value="Congo">Congo</option>
                                                <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                                                <option value="Cook Islands">Cook Islands</option>
                                                <option value="Costa Rica">Costa Rica</option>
                                                <option value="Cote D'ivoire">Cote D'ivoire</option>
                                                <option value="Croatia">Croatia</option>
                                                <option value="Cuba">Cuba</option>
                                                <option value="Cyprus">Cyprus</option>
                                                <option value="Czech Republic">Czech Republic</option>
                                                <option value="Denmark">Denmark</option>
                                                <option value="Djibouti">Djibouti</option>
                                                <option value="Dominica">Dominica</option>
                                                <option value="Dominican Republic">Dominican Republic</option>
                                                <option value="Ecuador">Ecuador</option>
                                                <option value="Egypt">Egypt</option>
                                                <option value="El Salvador">El Salvador</option>
                                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                                <option value="Eritrea">Eritrea</option>
                                                <option value="Estonia">Estonia</option>
                                                <option value="Ethiopia">Ethiopia</option>
                                                <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                                <option value="Faroe Islands">Faroe Islands</option>
                                                <option value="Fiji">Fiji</option>
                                                <option value="Finland">Finland</option>
                                                <option value="France">France</option>
                                                <option value="French Guiana">French Guiana</option>
                                                <option value="French Polynesia">French Polynesia</option>
                                                <option value="French Southern Territories">French Southern Territories</option>
                                                <option value="Gabon">Gabon</option>
                                                <option value="Gambia">Gambia</option>
                                                <option value="Georgia">Georgia</option>
                                                <option value="Germany">Germany</option>
                                                <option value="Ghana">Ghana</option>
                                                <option value="Gibraltar">Gibraltar</option>
                                                <option value="Greece">Greece</option>
                                                <option value="Greenland">Greenland</option>
                                                <option value="Grenada">Grenada</option>
                                                <option value="Guadeloupe">Guadeloupe</option>
                                                <option value="Guam">Guam</option>
                                                <option value="Guatemala">Guatemala</option>
                                                <option value="Guernsey">Guernsey</option>
                                                <option value="Guinea">Guinea</option>
                                                <option value="Guinea-bissau">Guinea-bissau</option>
                                                <option value="Guyana">Guyana</option>
                                                <option value="Haiti">Haiti</option>
                                                <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                                                <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                                                <option value="Honduras">Honduras</option>
                                                <option value="Hong Kong">Hong Kong</option>
                                                <option value="Hungary">Hungary</option>
                                                <option value="Iceland">Iceland</option>
                                                <option value="India">India</option>
                                                <option value="Indonesia">Indonesia</option>
                                                <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                                                <option value="Iraq">Iraq</option>
                                                <option value="Ireland">Ireland</option>
                                                <option value="Isle of Man">Isle of Man</option>
                                                <option value="Israel">Israel</option>
                                                <option value="Italy">Italy</option>
                                                <option value="Jamaica">Jamaica</option>
                                                <option value="Japan">Japan</option>
                                                <option value="Jersey">Jersey</option>
                                                <option value="Jordan">Jordan</option>
                                                <option value="Kazakhstan">Kazakhstan</option>
                                                <option value="Kenya">Kenya</option>
                                                <option value="Kiribati">Kiribati</option>
                                                <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                                                <option value="Korea, Republic of">Korea, Republic of</option>
                                                <option value="Kuwait">Kuwait</option>
                                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                                <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                                <option value="Latvia">Latvia</option>
                                                <option value="Lebanon">Lebanon</option>
                                                <option value="Lesotho">Lesotho</option>
                                                <option value="Liberia">Liberia</option>
                                                <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                                <option value="Liechtenstein">Liechtenstein</option>
                                                <option value="Lithuania">Lithuania</option>
                                                <option value="Luxembourg">Luxembourg</option>
                                                <option value="Macao">Macao</option>
                                                <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                                                <option value="Madagascar">Madagascar</option>
                                                <option value="Malawi">Malawi</option>
                                                <option value="Malaysia">Malaysia</option>
                                                <option value="Maldives">Maldives</option>
                                                <option value="Mali">Mali</option>
                                                <option value="Malta">Malta</option>
                                                <option value="Marshall Islands">Marshall Islands</option>
                                                <option value="Martinique">Martinique</option>
                                                <option value="Mauritania">Mauritania</option>
                                                <option value="Mauritius">Mauritius</option>
                                                <option value="Mayotte">Mayotte</option>
                                                <option value="Mexico">Mexico</option>
                                                <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                                <option value="Moldova, Republic of">Moldova, Republic of</option>
                                                <option value="Monaco">Monaco</option>
                                                <option value="Mongolia">Mongolia</option>
                                                <option value="Montenegro">Montenegro</option>
                                                <option value="Montserrat">Montserrat</option>
                                                <option value="Morocco">Morocco</option>
                                                <option value="Mozambique">Mozambique</option>
                                                <option value="Myanmar">Myanmar</option>
                                                <option value="Namibia">Namibia</option>
                                                <option value="Nauru">Nauru</option>
                                                <option value="Nepal">Nepal</option>
                                                <option value="Netherlands">Netherlands</option>
                                                <option value="Netherlands Antilles">Netherlands Antilles</option>
                                                <option value="New Caledonia">New Caledonia</option>
                                                <option value="New Zealand">New Zealand</option>
                                                <option value="Nicaragua">Nicaragua</option>
                                                <option value="Niger">Niger</option>
                                                <option value="Nigeria">Nigeria</option>
                                                <option value="Niue">Niue</option>
                                                <option value="Norfolk Island">Norfolk Island</option>
                                                <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                                <option value="Norway">Norway</option>
                                                <option value="Oman">Oman</option>
                                                <option value="Pakistan">Pakistan</option>
                                                <option value="Palau">Palau</option>
                                                <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                                <option value="Panama">Panama</option>
                                                <option value="Papua New Guinea">Papua New Guinea</option>
                                                <option value="Paraguay">Paraguay</option>
                                                <option value="Peru">Peru</option>
                                                <option value="Philippines">Philippines</option>
                                                <option value="Pitcairn">Pitcairn</option>
                                                <option value="Poland">Poland</option>
                                                <option value="Portugal">Portugal</option>
                                                <option value="Puerto Rico">Puerto Rico</option>
                                                <option value="Qatar">Qatar</option>
                                                <option value="Reunion">Reunion</option>
                                                <option value="Romania">Romania</option>
                                                <option value="Russian Federation">Russian Federation</option>
                                                <option value="Rwanda">Rwanda</option>
                                                <option value="Saint Helena">Saint Helena</option>
                                                <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                                <option value="Saint Lucia">Saint Lucia</option>
                                                <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                                <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                                <option value="Samoa">Samoa</option>
                                                <option value="San Marino">San Marino</option>
                                                <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                                <option value="Saudi Arabia">Saudi Arabia</option>
                                                <option value="Senegal">Senegal</option>
                                                <option value="Serbia">Serbia</option>
                                                <option value="Seychelles">Seychelles</option>
                                                <option value="Sierra Leone">Sierra Leone</option>
                                                <option value="Singapore">Singapore</option>
                                                <option value="Slovakia">Slovakia</option>
                                                <option value="Slovenia">Slovenia</option>
                                                <option value="Solomon Islands">Solomon Islands</option>
                                                <option value="Somalia">Somalia</option>
                                                <option value="South Africa">South Africa</option>
                                                <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                                                <option value="Spain">Spain</option>
                                                <option value="Sri Lanka">Sri Lanka</option>
                                                <option value="Sudan">Sudan</option>
                                                <option value="Suriname">Suriname</option>
                                                <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                                                <option value="Swaziland">Swaziland</option>
                                                <option value="Sweden">Sweden</option>
                                                <option value="Switzerland">Switzerland</option>
                                                <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                                <option value="Taiwan">Taiwan</option>
                                                <option value="Tajikistan">Tajikistan</option>
                                                <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                                <option value="Thailand">Thailand</option>
                                                <option value="Timor-leste">Timor-leste</option>
                                                <option value="Togo">Togo</option>
                                                <option value="Tokelau">Tokelau</option>
                                                <option value="Tonga">Tonga</option>
                                                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                                <option value="Tunisia">Tunisia</option>
                                                <option value="Turkey">Turkey</option>
                                                <option value="Turkmenistan">Turkmenistan</option>
                                                <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                                <option value="Tuvalu">Tuvalu</option>
                                                <option value="Uganda">Uganda</option>
                                                <option value="Ukraine">Ukraine</option>
                                                <option value="United Arab Emirates">United Arab Emirates</option>
                                                <option value="United Kingdom">United Kingdom</option>
                                                <option value="United States">United States</option>
                                                <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                                <option value="Uruguay">Uruguay</option>
                                                <option value="Uzbekistan">Uzbekistan</option>
                                                <option value="Vanuatu">Vanuatu</option>
                                                <option value="Venezuela">Venezuela</option>
                                                <option value="Viet Nam">Viet Nam</option>
                                                <option value="Virgin Islands, British">Virgin Islands, British</option>
                                                <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                                                <option value="Wallis and Futuna">Wallis and Futuna</option>
                                                <option value="Western Sahara">Western Sahara</option>
                                                <option value="Yemen">Yemen</option>
                                                <option value="Zambia">Zambia</option>
                                                <option value="Zimbabwe">Zimbabwe</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mob-50w">
                                        <div class="mb-3 form-area2">
                                            <label for="example1" class="form-label">{KYCLang.step2_2[this.state.Language]}*</label>
                                            <input type="text" class={this.state.name ? "form-control" : "form-control error-border"} id="example1" name="name" value={this.state.name ? this.state.name : ''} onChange={this.ChangeElement}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mob-50w">
                                        <div class="mb-3 form-area3">
                                            <label for="example2" class="form-label">{KYCLang.step2_3[this.state.Language]}*</label>
                                            <input type="text" class={this.state.surname ? "form-control" : "form-control error-border"} id="example2" name="surname" value={this.state.surname ? this.state.surname : ''} onChange={this.ChangeElement}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mob-50w">
                                        <div class="mb-3 form-area2">
                                            <label for="example3" class="form-label">{KYCLang.step2_4[this.state.Language]}*</label>
                                            <input type="date" class={this.state.birthday ? "form-control" : "form-control error-border"} id="example3" name="birthday" value={this.state.birthday ? this.state.birthday : ''} onChange={this.ChangeElement}/>
                                        </div>
                                    </div>
                                </div>
                                        
                                <div className="kyc-ttl2">
                                    {KYCLang.step2_5[this.state.Language]}
                                </div>

                                <div className="row mt25px">
                                    <div className="col-md-6 mob-50w">
                                        <div class="mb-3 form-area1">
                                            <label class="form-label">{KYCLang.step2_6[this.state.Language]}*</label>
                                            <select name="country" class={this.state.country ? "form-select" : "form-select error-border"} value={this.state.country ? this.state.country : ''} onChange={this.ChangeElement}>
                                                <option>{KYCLang.step2_6[this.state.Language]}</option>
                                                <option value="Afghanistan">Afghanistan</option>
                                                <option value="Åland Islands">Åland Islands</option>
                                                <option value="Albania">Albania</option>
                                                <option value="Algeria">Algeria</option>
                                                <option value="American Samoa">American Samoa</option>
                                                <option value="Andorra">Andorra</option>
                                                <option value="Angola">Angola</option>
                                                <option value="Anguilla">Anguilla</option>
                                                <option value="Antarctica">Antarctica</option>
                                                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                                <option value="Argentina">Argentina</option>
                                                <option value="Armenia">Armenia</option>
                                                <option value="Aruba">Aruba</option>
                                                <option value="Australia">Australia</option>
                                                <option value="Austria">Austria</option>
                                                <option value="Azerbaijan">Azerbaijan</option>
                                                <option value="Bahamas">Bahamas</option>
                                                <option value="Bahrain">Bahrain</option>
                                                <option value="Bangladesh">Bangladesh</option>
                                                <option value="Barbados">Barbados</option>
                                                <option value="Belarus">Belarus</option>
                                                <option value="Belgium">Belgium</option>
                                                <option value="Belize">Belize</option>
                                                <option value="Benin">Benin</option>
                                                <option value="Bermuda">Bermuda</option>
                                                <option value="Bhutan">Bhutan</option>
                                                <option value="Bolivia">Bolivia</option>
                                                <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                                <option value="Botswana">Botswana</option>
                                                <option value="Bouvet Island">Bouvet Island</option>
                                                <option value="Brazil">Brazil</option>
                                                <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                                <option value="Brunei Darussalam">Brunei Darussalam</option>
                                                <option value="Bulgaria">Bulgaria</option>
                                                <option value="Burkina Faso">Burkina Faso</option>
                                                <option value="Burundi">Burundi</option>
                                                <option value="Cambodia">Cambodia</option>
                                                <option value="Cameroon">Cameroon</option>
                                                <option value="Canada">Canada</option>
                                                <option value="Cape Verde">Cape Verde</option>
                                                <option value="Cayman Islands">Cayman Islands</option>
                                                <option value="Central African Republic">Central African Republic</option>
                                                <option value="Chad">Chad</option>
                                                <option value="Chile">Chile</option>
                                                <option value="China">China</option>
                                                <option value="Christmas Island">Christmas Island</option>
                                                <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                                <option value="Colombia">Colombia</option>
                                                <option value="Comoros">Comoros</option>
                                                <option value="Congo">Congo</option>
                                                <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                                                <option value="Cook Islands">Cook Islands</option>
                                                <option value="Costa Rica">Costa Rica</option>
                                                <option value="Cote D'ivoire">Cote D'ivoire</option>
                                                <option value="Croatia">Croatia</option>
                                                <option value="Cuba">Cuba</option>
                                                <option value="Cyprus">Cyprus</option>
                                                <option value="Czech Republic">Czech Republic</option>
                                                <option value="Denmark">Denmark</option>
                                                <option value="Djibouti">Djibouti</option>
                                                <option value="Dominica">Dominica</option>
                                                <option value="Dominican Republic">Dominican Republic</option>
                                                <option value="Ecuador">Ecuador</option>
                                                <option value="Egypt">Egypt</option>
                                                <option value="El Salvador">El Salvador</option>
                                                <option value="Equatorial Guinea">Equatorial Guinea</option>
                                                <option value="Eritrea">Eritrea</option>
                                                <option value="Estonia">Estonia</option>
                                                <option value="Ethiopia">Ethiopia</option>
                                                <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                                <option value="Faroe Islands">Faroe Islands</option>
                                                <option value="Fiji">Fiji</option>
                                                <option value="Finland">Finland</option>
                                                <option value="France">France</option>
                                                <option value="French Guiana">French Guiana</option>
                                                <option value="French Polynesia">French Polynesia</option>
                                                <option value="French Southern Territories">French Southern Territories</option>
                                                <option value="Gabon">Gabon</option>
                                                <option value="Gambia">Gambia</option>
                                                <option value="Georgia">Georgia</option>
                                                <option value="Germany">Germany</option>
                                                <option value="Ghana">Ghana</option>
                                                <option value="Gibraltar">Gibraltar</option>
                                                <option value="Greece">Greece</option>
                                                <option value="Greenland">Greenland</option>
                                                <option value="Grenada">Grenada</option>
                                                <option value="Guadeloupe">Guadeloupe</option>
                                                <option value="Guam">Guam</option>
                                                <option value="Guatemala">Guatemala</option>
                                                <option value="Guernsey">Guernsey</option>
                                                <option value="Guinea">Guinea</option>
                                                <option value="Guinea-bissau">Guinea-bissau</option>
                                                <option value="Guyana">Guyana</option>
                                                <option value="Haiti">Haiti</option>
                                                <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                                                <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                                                <option value="Honduras">Honduras</option>
                                                <option value="Hong Kong">Hong Kong</option>
                                                <option value="Hungary">Hungary</option>
                                                <option value="Iceland">Iceland</option>
                                                <option value="India">India</option>
                                                <option value="Indonesia">Indonesia</option>
                                                <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                                                <option value="Iraq">Iraq</option>
                                                <option value="Ireland">Ireland</option>
                                                <option value="Isle of Man">Isle of Man</option>
                                                <option value="Israel">Israel</option>
                                                <option value="Italy">Italy</option>
                                                <option value="Jamaica">Jamaica</option>
                                                <option value="Japan">Japan</option>
                                                <option value="Jersey">Jersey</option>
                                                <option value="Jordan">Jordan</option>
                                                <option value="Kazakhstan">Kazakhstan</option>
                                                <option value="Kenya">Kenya</option>
                                                <option value="Kiribati">Kiribati</option>
                                                <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                                                <option value="Korea, Republic of">Korea, Republic of</option>
                                                <option value="Kuwait">Kuwait</option>
                                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                                <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                                <option value="Latvia">Latvia</option>
                                                <option value="Lebanon">Lebanon</option>
                                                <option value="Lesotho">Lesotho</option>
                                                <option value="Liberia">Liberia</option>
                                                <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                                <option value="Liechtenstein">Liechtenstein</option>
                                                <option value="Lithuania">Lithuania</option>
                                                <option value="Luxembourg">Luxembourg</option>
                                                <option value="Macao">Macao</option>
                                                <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                                                <option value="Madagascar">Madagascar</option>
                                                <option value="Malawi">Malawi</option>
                                                <option value="Malaysia">Malaysia</option>
                                                <option value="Maldives">Maldives</option>
                                                <option value="Mali">Mali</option>
                                                <option value="Malta">Malta</option>
                                                <option value="Marshall Islands">Marshall Islands</option>
                                                <option value="Martinique">Martinique</option>
                                                <option value="Mauritania">Mauritania</option>
                                                <option value="Mauritius">Mauritius</option>
                                                <option value="Mayotte">Mayotte</option>
                                                <option value="Mexico">Mexico</option>
                                                <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                                <option value="Moldova, Republic of">Moldova, Republic of</option>
                                                <option value="Monaco">Monaco</option>
                                                <option value="Mongolia">Mongolia</option>
                                                <option value="Montenegro">Montenegro</option>
                                                <option value="Montserrat">Montserrat</option>
                                                <option value="Morocco">Morocco</option>
                                                <option value="Mozambique">Mozambique</option>
                                                <option value="Myanmar">Myanmar</option>
                                                <option value="Namibia">Namibia</option>
                                                <option value="Nauru">Nauru</option>
                                                <option value="Nepal">Nepal</option>
                                                <option value="Netherlands">Netherlands</option>
                                                <option value="Netherlands Antilles">Netherlands Antilles</option>
                                                <option value="New Caledonia">New Caledonia</option>
                                                <option value="New Zealand">New Zealand</option>
                                                <option value="Nicaragua">Nicaragua</option>
                                                <option value="Niger">Niger</option>
                                                <option value="Nigeria">Nigeria</option>
                                                <option value="Niue">Niue</option>
                                                <option value="Norfolk Island">Norfolk Island</option>
                                                <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                                <option value="Norway">Norway</option>
                                                <option value="Oman">Oman</option>
                                                <option value="Pakistan">Pakistan</option>
                                                <option value="Palau">Palau</option>
                                                <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                                <option value="Panama">Panama</option>
                                                <option value="Papua New Guinea">Papua New Guinea</option>
                                                <option value="Paraguay">Paraguay</option>
                                                <option value="Peru">Peru</option>
                                                <option value="Philippines">Philippines</option>
                                                <option value="Pitcairn">Pitcairn</option>
                                                <option value="Poland">Poland</option>
                                                <option value="Portugal">Portugal</option>
                                                <option value="Puerto Rico">Puerto Rico</option>
                                                <option value="Qatar">Qatar</option>
                                                <option value="Reunion">Reunion</option>
                                                <option value="Romania">Romania</option>
                                                <option value="Russian Federation">Russian Federation</option>
                                                <option value="Rwanda">Rwanda</option>
                                                <option value="Saint Helena">Saint Helena</option>
                                                <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                                <option value="Saint Lucia">Saint Lucia</option>
                                                <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                                <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                                <option value="Samoa">Samoa</option>
                                                <option value="San Marino">San Marino</option>
                                                <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                                <option value="Saudi Arabia">Saudi Arabia</option>
                                                <option value="Senegal">Senegal</option>
                                                <option value="Serbia">Serbia</option>
                                                <option value="Seychelles">Seychelles</option>
                                                <option value="Sierra Leone">Sierra Leone</option>
                                                <option value="Singapore">Singapore</option>
                                                <option value="Slovakia">Slovakia</option>
                                                <option value="Slovenia">Slovenia</option>
                                                <option value="Solomon Islands">Solomon Islands</option>
                                                <option value="Somalia">Somalia</option>
                                                <option value="South Africa">South Africa</option>
                                                <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                                                <option value="Spain">Spain</option>
                                                <option value="Sri Lanka">Sri Lanka</option>
                                                <option value="Sudan">Sudan</option>
                                                <option value="Suriname">Suriname</option>
                                                <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                                                <option value="Swaziland">Swaziland</option>
                                                <option value="Sweden">Sweden</option>
                                                <option value="Switzerland">Switzerland</option>
                                                <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                                <option value="Taiwan">Taiwan</option>
                                                <option value="Tajikistan">Tajikistan</option>
                                                <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                                <option value="Thailand">Thailand</option>
                                                <option value="Timor-leste">Timor-leste</option>
                                                <option value="Togo">Togo</option>
                                                <option value="Tokelau">Tokelau</option>
                                                <option value="Tonga">Tonga</option>
                                                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                                <option value="Tunisia">Tunisia</option>
                                                <option value="Turkey">Turkey</option>
                                                <option value="Turkmenistan">Turkmenistan</option>
                                                <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                                <option value="Tuvalu">Tuvalu</option>
                                                <option value="Uganda">Uganda</option>
                                                <option value="Ukraine">Ukraine</option>
                                                <option value="United Arab Emirates">United Arab Emirates</option>
                                                <option value="United Kingdom">United Kingdom</option>
                                                <option value="United States">United States</option>
                                                <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                                <option value="Uruguay">Uruguay</option>
                                                <option value="Uzbekistan">Uzbekistan</option>
                                                <option value="Vanuatu">Vanuatu</option>
                                                <option value="Venezuela">Venezuela</option>
                                                <option value="Viet Nam">Viet Nam</option>
                                                <option value="Virgin Islands, British">Virgin Islands, British</option>
                                                <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                                                <option value="Wallis and Futuna">Wallis and Futuna</option>
                                                <option value="Western Sahara">Western Sahara</option>
                                                <option value="Yemen">Yemen</option>
                                                <option value="Zambia">Zambia</option>
                                                <option value="Zimbabwe">Zimbabwe</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mob-50w">
                                        <div class="mb-3 form-area2">
                                            <label for="example4" class="form-label">{KYCLang.step2_5[this.state.Language]}*</label>
                                            <input type="text" class={this.state.address ? "form-control" : "form-control error-border"} id="example4" name="address" value={this.state.address ? this.state.address : ''} onChange={this.ChangeElement}/>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6 mob-50w">
                                        <div class="mb-3 form-area3">
                                            <label for="example5" class="form-label">{KYCLang.step2_7[this.state.Language]}*</label>
                                            <input type="text" class={this.state.postalcode ? "form-control" : "form-control error-border"} id="example5" name="postalcode" value={this.state.postalcode ? this.state.postalcode : ''} onChange={this.ChangeElement}/>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mob-50w">
                                        <div class="mb-3 form-area2">
                                            <label for="example6" class="form-label">{KYCLang.step2_8[this.state.Language]}*</label>
                                            <input type="text" class={this.state.city ? "form-control" : "form-control error-border"} id="example6" name="city" value={this.state.city ? this.state.city : ''} onChange={this.ChangeElement}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt25px">
                                    <div className="col-md-6 mob-50w">
                                        <progress max="100" value="20"></progress>
                                    </div>
                                    <div className="col-md-6 mob-50w text-right">
                                        {this.CheckUserInformation() ? (
                                            <Mutation mutation={KYC_USER} variables={{email: this.state.email, Name:this.state.name, Surname:this.state.surname, Birthday: this.state.birthday,
                                                PostalCode: this.state.postalcode, City:this.state.city, Address:this.state.address, Country:this.state.country, Nationality:this.state.nationality }}>
                                                {(KYCUser,{data, loading, error}) => {
                                                    return(
                                                        <div className="kyc-inline" onClick={event => this.UserUpdate(event, KYCUser)} >
                                                            <ButtonStandart ssilka='#' classname='ButtonStandart kyc-but kyc-inline' label={KYCLang.step2_continue[this.state.Language]}/>
                                                            {error && <p style={{ color: '#ff0404'}}>{error.message}</p>}
                                                        </div>
                                                    )
                                                }}
                                            </Mutation>
                                        ) : (
                                            <ButtonStandart ssilka='#' classname='ButtonStandartNotActive kyc-but kyc-inline' label={KYCLang.step2_continue[this.state.Language]}/>
                                        )}                                        
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 mt20-mob">
                                        <img className="kyc-protect" src={protect} />
                                        <div className="kyc-protect-info">
                                            {KYCLang.verify_info[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                            </>
                            }

                            { this.state.step3 && 
                            <>  
                                <img className="kyc-back" onClick={event => this.ChangeStep(event, 'step2')} src={back} />
                                <div className="kyc-ttl">
                                    {KYCLang.step3_1[this.state.Language]}
                                </div>
                                <div className="kyc-ttl2" style={{marginBottom: '10px'}}>
                                    {KYCLang.step3_2[this.state.Language]}
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className={ this.state.doc_type == 1 ? "kyc-select-area kyc-selected min-h338" : "kyc-select-area min-h338" } style={{marginLeft: '0px'}} onClick={event => this.SelectDoc(event, 1)}>
                                            <img className="id-card-img2" src={idcard} />
                                            <div className="kyc-area-ttl">
                                                {KYCLang.step3_3[this.state.Language]}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className={ this.state.doc_type == 2 ? "kyc-select-area kyc-selected min-h338" : "kyc-select-area min-h338" } onClick={event => this.SelectDoc(event, 2)}>
                                            <img className="passport-img" src={passport} />
                                            <div className="kyc-area-ttl">
                                                {KYCLang.step3_4[this.state.Language]}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className={ this.state.doc_type == 3 ? "kyc-select-area kyc-selected min-h338" : "kyc-select-area min-h338" } style={{marginRight: '0px'}} onClick={event => this.SelectDoc(event, 3)}>
                                            <img className="id-card-img" src={driver} />
                                            <div className="kyc-area-ttl">
                                                {KYCLang.step3_5[this.state.Language]}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt25px">
                                    <div className="col-md-6 mob-50w">
                                        <progress max="100" value="40"></progress>
                                    </div>
                                    <div className="col-md-6 mob-50w text-right">
                                        <div className="kyc-inline" onClick={event => this.ChangeStep(event, 'step4')}>
                                            <ButtonStandart ssilka='#' classname='ButtonStandart kyc-but kyc-inline' label={KYCLang.step2_continue[this.state.Language]}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 mt20-mob">
                                        <img className="kyc-protect" src={protect} />
                                        <div className="kyc-protect-info">
                                            {KYCLang.verify_info[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                                
                            </>
                            }

                            { this.state.step4 && 
                            <>
                                <img className="kyc-back" onClick={event => this.ChangeStep(event, 'step3')} src={back} />
                                <div className="kyc-ttl">
                                    {KYCLang.step3_1[this.state.Language]}
                                </div>
                                <div className="kyc-ttl2">
                                    {KYCLang.step4_1[this.state.Language]}
                                    { this.state.doc_type == 1 && ` ${KYCLang.step3_3[this.state.Language]}` }
                                    { this.state.doc_type == 2 && ` ${KYCLang.step3_4[this.state.Language]}` }
                                    { this.state.doc_type == 3 && ` ${KYCLang.step3_5[this.state.Language]}` }
                                </div>
                                <div className="row mt25px">

                                    <div className="col-md-6 hide-desk">

                                        <div className="row">
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-mob">
                                                    <img className="identity-img-example" src={id_good} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step4_2[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-mob">
                                                    <img className="identity-img-example" src={id_cut} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step4_3[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-mob">
                                                    <img className="identity-img-example" src={id_blur} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step4_4[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-mob">
                                                    <img className="identity-img-example" src={id_reflect} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step4_5[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div className="col-md-6">
                                        <div className="identity-img-area2">
                                            <img className="kyc-protect" style={{marginTop: '0px'}} src={info} />
                                            <div className="kyc-protect-info">
                                                {KYCLang.step4_6[this.state.Language]}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className={this.state.doc_type == 1 ? "col-md-12" : "col-md-12"}>
                                                <label onChange={(e)=>this.UploadImage(e, 'doc1')} >
                                                    <div className={this.state.doc_type == 1 ? "upload-img-block" : "upload-img-block min-h320"}>
                                                        <input className="StandartHidden" type="file" accept="image/*"/>
                                                        <img src={photoimg} className={this.state.doc_type == 1 ? "" : "pt75"}/>
                                                        <div className="kyc-area-ttl">
                                                            { this.state.doc_type == 1 && `${KYCLang.file_front[this.state.Language]}` }
                                                            { this.state.doc_type == 2 && `${KYCLang.upload_pass[this.state.Language]}` }
                                                            { this.state.doc_type == 3 && `${KYCLang.upload_driver[this.state.Language]}` }
                                                        </div>
                                                    </div>
                                                </label>
                                                { this.state.uploadDoc1 && 
                                                <div className="uploadedKYCimg">
                                                    <img width="16px" src={check}/> {KYCLang.file_upload[this.state.Language]}
                                                </div>}
                                                { this.state.FileImageToBig1 &&
                                                <div className="uploadedKYCimg">
                                                    {KYCLang.file_big_image[this.state.Language]}
                                                </div>}
                                            </div>
                                        </div>
                                        
                                        { this.state.doc_type == 1 && 
                                        <div className="row">
                                            <div className="col-md-12">
                                                <label onChange={(e)=>this.UploadImage(e, 'doc2')} >
                                                    <input className="StandartHidden" type="file" accept="image/*"/>
                                                    <div className="upload-img-block">
                                                        <img src={photoimg} />
                                                        <div className="kyc-area-ttl">
                                                            {KYCLang.file_back[this.state.Language]}
                                                        </div>
                                                    </div>
                                                </label>
                                                { this.state.uploadDoc2 && 
                                                <div className="uploadedKYCimg">
                                                    <img width="16px" src={check} /> {KYCLang.file_upload[this.state.Language]}
                                                </div>}
                                                { this.state.FileImageToBig2 &&
                                                <div className="uploadedKYCimg">
                                                    {KYCLang.file_big_image[this.state.Language]}
                                                </div>}
                                            </div>
                                        </div>
                                        }

                                    </div>
                                    <div className="col-md-6 hide-mob" style={{'padding-top': '40px'}}>

                                        <div className="row mt20">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-grid2">
                                                    <img className="identity-img-example" src={id_good} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step4_2[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-grid2">
                                                    <img className="identity-img-example" style={{marginBottom: '13px'}} src={id_cut} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step4_3[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-grid2">
                                                    <img className="identity-img-example" src={id_blur} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step4_4[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-grid2" style={{marginBottom: 0}}>
                                                    <img className="identity-img-example" style={{marginBottom: '13px'}} src={id_reflect} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step4_5[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div className="row mt25px">
                                    <div className="col-md-6 mob-50w">
                                        <progress max="100" value="60"></progress>
                                    </div>
                                    <div className="col-md-6 mob-50w text-right">
                                        { this.CheckDocuments() ? (
                                            <div className="kyc-inline" onClick={event => this.ChangeStep(event, 'step5')}>
                                                <ButtonStandart ssilka='#' classname='ButtonStandart kyc-but kyc-inline' label={KYCLang.step2_continue[this.state.Language]}/>
                                            </div>
                                        ) : (
                                            <div className="kyc-inline">
                                                <ButtonStandart ssilka='#' classname='ButtonStandartNotActive kyc-but kyc-inline' label={KYCLang.step2_continue[this.state.Language]}/>
                                            </div>
                                        )}
                                        
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12 mt20-mob">
                                        <img className="kyc-protect" src={protect} />
                                        <div className="kyc-protect-info">
                                            {KYCLang.verify_info[this.state.Language]}
                                        </div>
                                    </div>
                                </div>

                                <Mutation mutation={ADD_KYC_DOC1} variables={{userid: this.props.session._id, email: this.state.email, doc1: this.state.doc1}}>
                                    {(addKYCdoc1,{data, loading, error}) => {
                                        return(
                                            <div onClick={event => this.KYCdoc1(event, addKYCdoc1)} id="KYCdoc1" style={{display: 'none'}}>
                                                <ButtonStandart ssilka='#' label="KYCdoc1" />                                            
                                            </div>
                                        )
                                    }}
                                </Mutation>

                                <Mutation mutation={ADD_KYC_DOC2} variables={{userid: this.props.session._id, email: this.state.email, doc2: this.state.doc2}}>
                                    {(addKYCdoc2,{data, loading, error}) => {
                                        return(
                                            <div onClick={event => this.KYCdoc2(event, addKYCdoc2)} id="KYCdoc2" style={{display: 'none'}}>
                                                <ButtonStandart ssilka='#' label="KYCdoc2" />                                            
                                            </div>
                                        )
                                    }}
                                </Mutation>
                            </>
                            }

                            { this.state.step5 && 
                            <>
                                <img className="kyc-back" onClick={event => this.ChangeStep(event, 'step4')} src={back} />
                                <div className="kyc-ttl">
                                    {KYCLang.step3_1[this.state.Language]}
                                </div>
                                <div className="kyc-ttl2">
                                    {KYCLang.step5_1[this.state.Language]}
                                </div>
                                {/* <div className="kyc-ttl2">
                                    Hold up your identity document, like the example
                                </div> */}

                                <div className="row mt25px">
                                    <div className="col-md-6 hide-desk">

                                        <div className="row">
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-mob">
                                                    <img className="identity-img-example" src={ligth} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step5_2[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-mob">
                                                    <img className="identity-img-example" src={filter} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step5_3[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-mob">
                                                    <img className="identity-img-example" src={fsize} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step5_4[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-mob">
                                                    <img className="identity-img-example" style={{height: '40px', width: '40px'}} src={glasses} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step5_5[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div className="col-md-6">
                                        <div className="identity-img-area2">
                                            <img className="kyc-protect" style={{marginTop: '0px'}} src={info} />
                                            <div className="kyc-protect-info">
                                                {KYCLang.step4_6[this.state.Language]}
                                            </div>
                                        </div>
                                        <label onChange={(e)=>this.UploadImage(e, 'selfie')} >
                                            <input className="StandartHidden" type="file" accept="image/*"/>
                                            <div className="upload-img-block min-h320">
                                                <img src={photoimg} className="pt75"/>
                                                <div className="kyc-area-ttl">
                                                    {KYCLang.step5_1[this.state.Language]}
                                                </div>
                                            </div>
                                        </label>
                                        { this.state.uploadDoc3 && 
                                        <div className="uploadedKYCimg">
                                            <img width="16px" src={check} /> {KYCLang.file_upload[this.state.Language]}
                                        </div>}
                                        { this.state.FileImageToBig3 &&
                                        <div className="uploadedKYCimg">
                                            {KYCLang.file_big_image[this.state.Language]}
                                        </div>}
                                    </div>

                                    <div className="col-md-6 hide-mob" style={{'padding-top': '40px'}}>

                                        <div className="row mt20">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-grid2">
                                                    <img className="identity-img-example" src={ligth} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step5_2[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-grid2">
                                                    <img className="identity-img-example" style={{height: '43px'}} src={filter} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step5_3[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-grid2">
                                                    <img className="identity-img-example" src={fsize} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step5_4[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6 mob-50w">
                                                <div className="identity-img-area-grid2" style={{marginBottom: 0}}>
                                                    <img className="identity-img-example" style={{height: '31px'}} src={glasses} />
                                                    <div className="kyc-area-ttl2">
                                                        {KYCLang.step5_5[this.state.Language]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div className="row mt25px">
                                    <div className="col-md-6 mob-50w">
                                        <progress max="100" value="80"></progress>
                                    </div>
                                    <div className="col-md-6 mob-50w text-right">
                                        { this.CheckSelfie() ? (
                                            <Mutation mutation={SAVE_KYC} variables={{email: this.state.email, start: true, doc_type: this.state.doc_type}}>
                                            {(saveKYC,{data, loading, error}) => {
                                                return(
                                                    <div className="kyc-inline" onClick={event => this.KYCsave(event, saveKYC)}>
                                                        <ButtonStandart ssilka='#' classname='ButtonStandart kyc-but kyc-inline' label={KYCLang.step2_continue[this.state.Language]}/>                                            
                                                    </div>
                                                )
                                            }}
                                            </Mutation>
                                        ) : (
                                            <div className="kyc-inline">
                                                <ButtonStandart ssilka='#' classname='ButtonStandartNotActive kyc-but kyc-inline' label={KYCLang.step2_continue[this.state.Language]}/>
                                            </div>
                                        )}                                        
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12 mt20-mob">
                                        <img className="kyc-protect" src={protect} />
                                        <div className="kyc-protect-info">
                                            {KYCLang.verify_info[this.state.Language]}
                                        </div>
                                    </div>
                                </div>

                                <Mutation mutation={ADD_KYC_DOC3} variables={{email: this.state.email, selfie: this.state.selfie}}>
                                    {(addKYCdoc3,{data, loading, error}) => {
                                        return(
                                            <div onClick={event => this.KYCdoc3(event, addKYCdoc3)} id="KYCselfie" style={{display: 'none'}}>
                                                <ButtonStandart ssilka='#' label="KYCselfie" />                                            
                                            </div>
                                        )
                                    }}
                                </Mutation>
                            </>
                            }

                           { this.state.step6 && 
                            <>
                                <img className="complaint-img" src={kyc_start}/>
                                <div className="kyc-ttl text-center mt80ke">
                                    {KYCLang.review[this.state.Language]}
                                </div>
                                <div className="review-text" style={{marginBottom: '105px'}}>
                                    {KYCLang.recive[this.state.Language]}<br/>
                                    {KYCLang.time[this.state.Language]} {KYCLang.day[this.state.Language]}.
                                </div>

                                <div className="row mt25px">
                                    <div className="col-md-6 mob-50w">
                                        <progress max="100" value="100"></progress>
                                    </div>
                                    <div className="col-md-6 mob-50w text-right">
                                        <div className="kyc-inline" onClick={event => window.open(`${this.state.SITE_ADDRESS}`, '_top')}>
                                            <ButtonStandart ssilka='#' classname='ButtonStandart kyc-but kyc-inline' label="OK"/>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <img className="kyc-protect" src={protect} />
                                        <div className="kyc-protect-info">
                                            {KYCLang.verify_info[this.state.Language]}
                                        </div>
                                    </div>
                                </div>
                            </>
                            }
                        </div>
                        
                    </div>
                </div>
            
            </div>
            
        )
    }
}

export default withAuth(session => session && session)(withRouter(KYC_inner));
